/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

import Personas from "../../models/componentModels/Personas";
import getRelevantUsersBasedOnPersona from "./getRelevantUsersBasedOnPersona";

const getTenantUsersBasedOnSearchandFilterAndPersona = (
  filteredUsers: any[],
  searchText: string,
  user_persona: Personas
) => {
  let gridDataForTenantUsers = filteredUsers.filter(
    (x: any) =>
      searchText === "" ||
      ((x.firstName &&
        (((x.firstName as string) + " " + x.lastName) as string)) != "" &&
        (((x.firstName as string) + " " + x.lastName) as string)

          .toLowerCase()

          .includes(searchText.toLowerCase().trim())) ||
      (x.emailId &&
        (x.emailId as string)
          .toLowerCase()
          .includes(searchText.toLowerCase().trim()))
  );
  // Filter based on user persona

  let personaRelatedUsers = getRelevantUsersBasedOnPersona(
    gridDataForTenantUsers,
    user_persona
  );

  return personaRelatedUsers;
};

export default getTenantUsersBasedOnSearchandFilterAndPersona;
